import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UnavailableDate } from './unavailable-date.model';
import { UnavailableDateService } from './unavailable-date.service';
import { HttpErrorResponse } from '@angular/common/http';
@Injectable()
export class UnavailableDatePopupService {
    private isOpen = false;
    constructor(
        private modalService: NgbModal,
        private router: Router,
        private unavailableDateService: UnavailableDateService

    ) { }

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.unavailableDateService.find(id).subscribe(unavailableDate => {
                if (unavailableDate.begining) {
                    unavailableDate.begining = {
                        year: unavailableDate.begining.getFullYear(),
                        month: unavailableDate.begining.getMonth() + 1,
                        day: unavailableDate.begining.getDate()
                    };
                }
                if (unavailableDate.ending) {
                    unavailableDate.ending = {
                        year: unavailableDate.ending.getFullYear(),
                        month: unavailableDate.ending.getMonth() + 1,
                        day: unavailableDate.ending.getDate()
                    };
                }
                this.unavailableDateModalRef(component, unavailableDate);
            }, (error: HttpErrorResponse) => {
                this.isOpen = false;
            });
        } else {
            setTimeout(() => {
                // the setTimeout is needed to avoid ExpressionChangedAfterItHasBeenCheckedError error in dev mode
                return this.unavailableDateModalRef(component, new UnavailableDate());
            });
        }
    }

    unavailableDateModalRef(component: Component, unavailableDate: UnavailableDate): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.unavailableDate = unavailableDate;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/unavailable-date/unavailable-date-popup.service.ts